import * as helper from "./../../../../../VX/View/Assets/Js/helper";
import { handleValidation, isFilled, handleEmailError, handleusernameError, STATUS_EMAIL, STATUS_USERNAME} from "./../../../Assets/HandleValidation";

helper.onDocumentLoaded(() => {
    window.addEventListener('keydown',function(e) {
        if (e.key =='Enter' ) {
            e.preventDefault();
        }
    }, true);

    const signupBox = helper.$("#signupBox");
    const controller = new AbortController();
	const emailValidationUrl = helper.getData(signupBox, "emailvalidationurl");
	const usernameValidationUrl = helper.getData(signupBox, "usernamevalidationurl");

    const inputUsername = helper.$("#username");
	const inputEmail = helper.$("#email");
	const suggestions = helper.$("#suggestions");
	const error_user = helper.$("#error_user");
	const error_email = helper.$("#error_email");
	const errors = {username: true, email: true};
	const submitButton = helper.$("#signup");

    function handleSuggestion (e) {
		inputUsername.value = e.textContent;
		suggestions.style.display = "none";
	}

	const makeList = (list) => {
		const ul = document.createElement("ul");
		const container = document.createElement("div");
		container.classList.add("suggestions_wrapper");
		const h6 = document.createElement("h6");
		let items;
		// sometimes the api returns an object instead of an array XD
		if (Array.isArray(list)){
			items = list.map((item) => {
				const li = document.createElement("li");
				li.classList.add("suggested_username");
				li.textContent = item;
				return li;
			});	
		}else{
			items = Object.keys(list).map((item) => {
				const li = document.createElement("li");
				li.classList.add("suggested_username");
				li.textContent = list[item];
				return li;
			})
		}
		h6.textContent = "Username Suggestions";
		ul.append(...items);
		container.append(ul);
		container.prepend(h6);
		return container;
	}

	const itemSuggestionsListeners = () =>{
		const items = document.querySelectorAll(".suggested_username");
		items.forEach((item) => {
			helper.addEventListener(item, "click", (e) => {
				handleSuggestion(item);
				error_user.innerHTML = "";
				error_user.style.display = "none";
				errors.username = false;
				setSubmintButtonState();
			});
		});
	}

	function validateUsername(){
		if(isFilled(inputUsername.value)) {
			const data = handleValidation(usernameValidationUrl, inputUsername.value, controller);
			data.then((res) => {
				if(res.data?.userNameSuggestions) {
					suggestions.innerHTML = makeList(res.data.userNameSuggestions).outerHTML;
					suggestions.style.display = "block";
					itemSuggestionsListeners();
					errors.username = true;
					error_user.innerHTML = handleusernameError(res.data.status);
					error_user.style.display = "block";					
					setSubmintButtonState();
				}else{
					if(res.data.status === (STATUS_USERNAME.OK || STATUS_USERNAME.OKE)) {
						errors.username = false;
						error_user.innerHTML = "";
						error_user.style.display = "none";
						suggestions.style.display = "none";
						setSubmintButtonState();
					}
				}
			});
		}
	}

	helper.addEventListener(inputUsername, "input", validateUsername);

	function setSubmintButtonState() {
		submitButton.disabled = (errors.email || errors.username);
	}

	function validateEmail(){
		const data = handleValidation(emailValidationUrl, inputEmail.value, controller);
		data.then((res) => {
			if(res.data.status === (STATUS_EMAIL.OK || STATUS_EMAIL.OKE)) {
				errors.email = false;
				error_email.innerHTML = "";
				error_email.style.display = "none";
				setSubmintButtonState();
			}else{
				error_email.innerHTML = handleEmailError(res.data.status);
				error_email.style.display = "block";
				errors.email = true;
				setSubmintButtonState();
			}
		})
	}
	helper.addEventListener(inputEmail, "input", validateEmail);

	validateUsername();
	validateEmail();

    // wait for the previous script to finish
    setTimeout(() => {
        submitButton.disabled = (errors.email || errors.username);
    }, 1000);

});